<template>
  <div>
    <p class="text-muted small mb-4" v-if="!isOffice && !isOfficial">
      Define a quién se reenviará el flujo y cómo continuará el proceso.
    </p>
    <div class="row">
      <div class="col-6" v-if="!isOffice && !isOfficial">
        <b-form-group
          label="Tipo de destinatario"
          label-cols="12"
          label-class="font-weight-semibold"
        >
          <div class="d-flex">
            <b-form-radio
              v-model="resendSubject.type"
              :value="stepTypes.usuario"
              button
              button-variant="outline-primary"
              class="mr-2"
              @input="emitData"
            >
              Usuario
            </b-form-radio>
            <b-form-radio
              v-model="resendSubject.type"
              :value="stepTypes.grupo"
              button
              button-variant="outline-primary"
              @input="emitData"
            >
              Grupo
            </b-form-radio>
          </div>
        </b-form-group>
      </div>
      <div class="col-6">
        <div v-if="resendSubject.type === stepTypes.usuario && !isOffice && !isOfficial">
          <list-user
            class="w-100"
            autocomplete
            label="Usuario"
            name="userStep"
            v-model="resendSubject.id"
            ref="resendName"
            @input="emitSelectData"
            v-validate="'required'"
          />
        </div>
        <div v-if="resendSubject.type === stepTypes.grupo && !isOffice && !isOfficial">
          <list-groups
            class="w-100"
            autocomplete
            label="Grupo"
            name="groupStep"
            v-model="resendSubject.id"
            ref="resendName"
            @input="emitSelectData"
          />
        </div>
        <div v-if="isOffice && !isOfficial">
          <list-groups
            :filter-office="true"
            :actual-office="stepId.paso.tipoValorResponsableId"
            :disabled="searchingConfig"
            class="w-100"
            autocomplete
            :label="officeLabel"
            name="groupStep"
            v-model="resendSubject.id"
            ref="resendName"
            :type-list="officeType.codeType"
            :office-type="officeType.type"
            @input="emitSelectData"
          />
        </div>
      </div>
      <div class="col-12 mt-2">
        <small class="text-warning" v-if="searchingConfig">
          Estamos buscando si esta oficina cuenta con la configuración
          de folios para este tipo de documento
        </small>
        <div
          v-if="error.message !== ''"
          class="con-text-validation span-text-validation-danger
                 vs-input--text-validation-span v-enter-to text-right"
          style="height: 32px;"
        >
          <span class="span-text-validation">
            {{ error.message }}
          </span>
        </div>
      </div>
      <div class="col-12 mt-2" v-if="!isOffice && !isOfficial">
        <div class="row">
          <div class="col-md-6 mb-3">
            <b-form-group
              label="Tipo de paso a asignar"
              label-for="rol-tipo-select"
              label-cols="12"
              label-class="font-weight-semibold"
              description="Define el rol con el que actuará el nuevo destinatario."
            >
              <b-form-select
                id="rol-tipo-select"
                v-model="resendSubject.tipoRol"
                class="w-100"
                @change="emitData"
              >
                <b-form-select-option :value="null" disabled>
                  Seleccione tipo de paso
                </b-form-select-option>

                <b-form-select-option
                  v-if="canShowReviewer"
                  :value="rolTypesCode.revisor"
                >
                  Revisor
                </b-form-select-option>

                <b-form-select-option
                  v-if="canShowApprover"
                  :value="rolTypesCode.aprobador"
                >
                  Aprobador
                </b-form-select-option>

                <b-form-select-option
                  v-if="canShowSigner"
                  :value="rolTypesCode.firmante"
                >
                  Firmante
                </b-form-select-option>
              </b-form-select>
            </b-form-group>
          </div>
          <div class="col-md-6 mb-3">
            <b-form-group
              label="Comportamiento del flujo"
              label-cols="12"
              label-class="font-weight-semibold"
            >
              <div class="d-flex flex-column">
                <div class="d-flex mb-1">
                  <b-form-radio
                    v-model="resendSubject.continueFlow"
                    :value="true"
                    button
                    button-variant="outline-primary"
                    class="mr-2"
                    @input="emitData"
                  >
                    Que continúe
                  </b-form-radio>
                  <b-form-radio
                    v-model="resendSubject.continueFlow"
                    :value="false"
                    button
                    button-variant="outline-primary"
                    @input="emitData"
                  >
                    Que vuelva a mí
                  </b-form-radio>
                </div>
                <small class="text-muted">
                  <span v-if="resendSubject.continueFlow === true">
                    Si eliges que <b>continúe</b>, el flujo continuará al paso después de este.
                  </span>
                  <span v-else>
                    Si eliges que <b>vuelva a ti</b>,
                    luego de que el usuario/grupo que selecciones apruebe,
                    volverá este flujo a tu bandeja.
                  </span>
                </small>
              </div>
            </b-form-group>
          </div>
        </div>
      </div>
      <div class="col-12" v-if="isOfficial">
        <div>
          <list-group-users
            class="w-100"
            autocomplete
            label="Usuarios de la oficina"
            name="userStep"
            v-model="resendSubject.id"
            :parent-value="officialOfficeId"
            ref="resendName"
            @input="emitSelectData"
            v-validate="'required'"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import ListUser from '@/febos/chile/lists/components/ListUser';
import ListGroups from '@/febos/chile/lists/components/ListGroups';
import { rolTypesCode, stepTypesCode } from '@/febos/chile/approvals/components/trays/managementTray/constants';
import { getSheetsConfig } from '@/febos/servicios/api/dnt.api';
import ListGroupUsers from '@/febos/chile/lists/components/ListGroupUsers';
import RolTypes from '@/febos/chile/dnt/mixins/RolTypes';

export default {
  components: {
    ListUser,
    ListGroups,
    ListGroupUsers
  },
  data() {
    return {
      searchingConfig: false,
      resendSubject: this.value || {},
      stepTypes: stepTypesCode,
      rolTypesCode,
      rolTypes: RolTypes,
      error: {
        message: ''
      }
    };
  },
  watch: {
    value() {
      this.resendSubject = this.value;
    },
    'resendSubject.continueFlow': function (newVal) {
      // Si es el último paso, el tipo de rol es revisor y cambia a 'Que continúe', limpiar tipoRol
      if (
        this.isLastStep
        && newVal === true
        && this.resendSubject.tipoRol === this.rolTypesCode.revisor
      ) {
        this.resendSubject.tipoRol = null;
        this.emitData();
      }
    }
  },
  computed: {
    ...mapGetters('Approvals', [
      'loading',
      'fileOnFlow',
      'fileOnFlowAttachments'
    ]),
    officeLabel() {
      return this.officeType && this.officeType.type === 'int' ? 'Oficinas internas' : 'Oficinas de partes';
    },
    currentStep() {
      const {
        detalle: {
          pasos = [],
          ejecucion
        } = {}
      } = this.fileOnFlow;
      return pasos
        .find((step) => (
          step.id === ejecucion.pasoActualId
        ));
    },
    isLastStep() {
      // Devuelve true si el paso actual es el último del flujo
      const { detalle: { pasos = [], ejecucion } = {} } = this.fileOnFlow;
      if (!pasos.length || !ejecucion) return false;
      const idx = pasos.findIndex((step) => step.id === ejecucion.pasoActualId);
      return idx === pasos.length - 1;
    },
    hasSignaturePosition2() {
      return (
        ((this.stepId.x && this.stepId.x !== '')
          && (this.stepId.y && this.stepId.y !== '')
          && (this.stepId.pagina && this.stepId.pagina !== ''))
      );
    },
    isSignerComputed() {
      const { detalle = {} } = this.fileOnFlow;
      const { pasos = [], ejecucion } = detalle;
      return pasos
        .some((step) => (
          step.id === ejecucion.pasoActualId
          && step.paso.aprobacionesTipoRolId === rolTypesCode.firmante
        ));
    },
    hasPositionSign() {
      return ((this.isSigner || this.isSignerComputed) && this.hasSignaturePosition2);
    },
    hasPositionedSignature() {
      const { detalle = {} } = this.fileOnFlow || {};
      const { ejecucion = {} } = detalle;
      return ejecucion.firmaPosicionada === 'Y';
    },

    continueFlow() {
      return this.resendSubject.continueFlow;
    },

    // REGLA 1: Mostrar Revisor?
    canShowReviewer() {
      // REGLA GLOBAL: Nunca puede quedar como último paso revisor con "que continúe"
      if (this.isLastStep && this.continueFlow) {
        return false;
      }
      return true;
    },

    // REGLA 2: Aprobador siempre disponible
    canShowApprover() {
      return true;
    },

    // REGLA 3: Mostrar Firmante?
    canShowSigner() {
      // Flujo CON firma posicionada
      if (this.hasPositionedSignature) {
        if (this.continueFlow) {
          return this.isSignerComputed; // "Que continúe" solo si quien reenvía es firmante
        }
        return false; // "Que vuelva a mí" NO mostrar firmante
      }

      // Flujo SIN firma posicionada
      if (!this.isLastStep) {
        return true; // No es último paso, siempre puede ser firmante
      }
      // Es último paso sin firma posicionada
      return true;
    },
  },
  methods: {
    async searchConfigSheets() {
      this.searchingConfig = true;
      const officeId = this.resendSubject.id;
      const document = this.fileOnFlow?.detalle?.ejecucion?.tipoDocumentoId;
      const { data: { configFolios = [] } } = await getSheetsConfig({
        tipoDocId: document,
        alcanceId: officeId
      });

      this.searchingConfig = false;
      if (!configFolios.length) {
        this.error.message = 'No existe configuración de numeración para este documento';
        this.$emit('can-resend-to-office', false);
      }
      if (configFolios.length) {
        this.$emit('can-resend-to-office', true);
        this.$emit('input', {
          ...this.resendSubject,
          type: this.stepTypes.oficina,
          tipoRol: this.rolTypesCode.firmante,
          name: this.$refs.resendName.getOption().label
        });
      }
    },
    emitSelectData() {
      this.error.message = '';
      if (this.isOffice) {
        this.searchConfigSheets();
      } else {
        this.$nextTick(() => {
          this.$emit('input', {
            ...this.resendSubject,
            name: this.$refs.resendName.getOption().label
          });
        });
      }
    },
    emitData() {
      this.$emit('input', this.resendSubject);
    }
  },
  props: {
    value: {
      type: Object,
      required: true,
      default: () => {
      }
    },
    officeType: { type: Object },
    isSigner: { type: Boolean, default: false },
    stepId: Object,
    hasSignaturePosition: { type: Boolean },
    isOffice: { type: Boolean, default: false },
    isOfficial: { type: Boolean, default: false },
    officialOfficeId: { type: String, default: '' }
  }
};
</script>

<style scoped>
.type-resend {
  justify-content: flex-start;
}

.font-weight-semibold {
  font-weight: 600;
}
</style>
